export default {"src":"/_next/static/media/with-trees.bb649ecb.svg","height":25,"width":30,"blurWidth":0,"blurHeight":0};